// extracted by mini-css-extract-plugin
export var highlightFade = "_3d-4";
export var highlighted = "_3d-3";
export var table = "_3d-1";
export var tableContainer = "_3d-0";
export var totalsRow = "_3d-2";